import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import * as ReportDetailsActions from '@ruby/modules/customized-reporting/store/actions/report-details.actions';
import * as fromReportDetails from '@ruby/modules/customized-reporting/store/reducers/report-details.reducer';
import * as ReportDetailsSelectors from '@ruby/modules/customized-reporting/store/selectors/report-details.selectors';

@Component({
  selector: 'ng-report-details-container',
  template: `
    <ng-report-details *ngIf="(store$ | async) as store" [data]="store.report"></ng-report-details>
  `
})
export class ReportDetailsContainer {
  store$: Observable<fromReportDetails.State>;

  constructor(private store: Store<fromReportDetails.State>, @Inject(MAT_DIALOG_DATA) public data: number) {
    this.store$ = this.store.select(ReportDetailsSelectors.selectReportDetailsState);
    this.store.dispatch(ReportDetailsActions.loadReportDetails({ data: this.data }));
  }
}
